
<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="obligationperiodForm">
    <div class="">
      <h3 class="form_name">ObligationPeriod</h3>


        <div class="input">
          <label for="">Obligation Period Name</label>
          <input type="text" class="default_input reference-form" formControlName="ObligationPeriodName" />
          <label for="">Obligation Period Days</label>
          <input type="text" class="default_input reference-form" formControlName="ObligationPeriodDays" />
    
        </div>


      <div class="btn_holder">
        <button class="default_primary-button" *ngIf="selectedIndex === null" (click)="addNew(obligationperiodForm.value)">Add</button>
        <button class="default_primary-button" *ngIf="selectedIndex !== null"
            (click)="addNew(obligationperiodForm.value)">Update</button>
        <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

      </div>

    </div>
  </form>
    <div class="display_table">
      <div class="search_container">
        <input type="text" class="default_input search"
        placeholder="Search for ObligationPeriod"
        [formControl]="control"
        [appAutocomplete]="autocomplete"
        />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container
              *ngIf="(obligationperiods | filterReference: control.value) as result"
            >
              <app-option
                (click)="selectObligationPeriod(option.id)"
                *ngFor="let option of result"
                [value]="option.ObligationPeriodName"
              >
                {{ option.ObligationPeriodName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length"
                >No result...</app-option
              >
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head" >
        <span class="item">S/N</span>
        <span class="item">Obligation Period Name</span>
        <span class="item">Obligation Period Days</span>
        <span class="item">Action</span>

      </div>

    <div class="scroll">

    </div>
    <div class="body_content" >
      <div class="the_body"
      *ngFor="let obligationperiod of obligationperiodFormArray.get('ObligationPeriods')['controls']; index as i"
      (click)="onEdit(i, obligationperiod.value)" style="cursor: pointer;"
      matTooltip="Click to edit"
        aria-label="Button that displays a tooltip when focused or hovered over"
      >
        <span class="content">{{i + 1}}</span>
        <span class="content">{{obligationperiod.value.ObligationPeriodName}}</span>
        <span class="content">{{obligationperiod.value.ObligationPeriodDays}}</span>

        <span class="content" (click)="$event.stopImmediatePropagation()">
          <button
          class="delete_icon trash"

          (click)="deleteObligationPeriod(i, obligationperiod.value)">
          <em class="ti-trash"> </em> </button>
        </span>

      </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(obligationperiodFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
